module.exports = __webpack_public_path__ + "static/media/25.f1a55e3e.png";